import { MiniMapStyle } from './styles';

import ToogleIcon from './assets/toogle-icon.svg';

/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap, é uma biblioteca de mapeamento 
 * leve e de codigo aberto, utiliza um banco de dados geografico editável gratuito.
 */
import L from 'leaflet';
import LeafletMiniMap from 'leaflet-minimap';
/**
 * useEffect é um hook que permite executar efeitos colaterais em seus componentes, por exemplo: 
 * buscar dados, atualizar diretamente o DOM e cronômetros, ele aceita dois argumentos o segundo 
 * é opcional.
 * 
 * useState é um hook que nos permite rastrear o estado em um componente de função, o estado 
 * geralmente se refere a dados ou propriedads que precisam ser rastreador em um aplicativo.
 */
import { useEffect, useState } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia, todos os módulos criados na ADM.
 */
import { useMap } from 'views/MapView/hooks';

import 'leaflet-minimap/dist/Control.MiniMap.min.css';

const MiniMap = ({ ...props }) => {
  const [miniMap, setMiniMap] = useState(null);
  const { map, loadingMap } = useMap();

  useEffect(() => {
    if (map && !loadingMap && !miniMap) {
      let baseMap = new L.TileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          minZoom: 4,
          maxZoom: 4,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }
      );

      let lMiniMap = new LeafletMiniMap(baseMap, {
        width: 120,
        height: 120,
        toggleDisplay: true,
        autoToggleDisplay: true,
        minimized: true,
        strings: { hideText: 'Esconder Mapa de Referência', showText: 'Exibir Mapa de Referência' },
        collapsedWidth: 18,
        collapsedHeight: 18,
        zoomLevelFixed: 4,
        centerFixed: [-13.43787561, -41.98166245],
        aimingRectOptions: {
          lineCap: 'round',
          lineJoin: 'round',
          className: 'retangulo-minimap',
        },
        shadowRectOptions: {
          className: 'retangulo-minimap-shadow',
        },
      });

      lMiniMap.addTo(map);
      setMiniMap(lMiniMap);
    } else if (loadingMap && miniMap) {
      setMiniMap(null);
    }
  }, [map, miniMap, loadingMap]);

  return (
    <div id="mini-map">
      <MiniMapStyle toogleIcon={ToogleIcon} />
    </div>
  );
};

MiniMap.properties = {
  id: 'CPN-MA_MINIMAP',
  alias: 'Encarte',
  description: '...',
};

export default MiniMap;
